define([
    "jquery",
    "underscore",
    "marionette",
    "views/withdrawal/common_view",
    "forms/withdrawal/web_money_form"
], function($, _, Marionette, CommonView, WebMoneyForm) {
    return CommonView.extend({
        initialize: function(){
            this.bindUIElements();
            this.form = new WebMoneyForm();
        }
    });
});
